import React, { useEffect, useRef, useState } from "react";
import classes from "./Giving.module.css";
//components:
import Button from "../UI/Button/Button";
import Modal from "../UI/Modal/Modal";
import CurveNameForm from "./GivingForms/CurveNameForm/CurveNameForm";
import LSEForm from "./GivingForms/LSEForm/LSEForm";
import SponsorEventsForm from "./GivingForms/SponsorEventsForm/SponsorEventsForm";
import DonationForm from "./GivingForms/DonationForm/DonationForm";
import AidForm from "./GivingForms/AidForm/AidForm";

//Libraries
import gsap from "gsap";
import { ScrollTrigger } from "gsap/all";
//This components displays 5 buttons that open forms for various donations
const Giving = () => {
  gsap.registerPlugin(ScrollTrigger);
  const container = useRef(null);

  //states responsibile for opening Modals
  const [isCurveModalOpen, setIsCurveModalOpen] = useState(false);
  const [isLSEOpen, setIsLSEOpen] = useState(false);
  const [isSponsorOpen, setIsSponsorOpen] = useState(false);
  const [isDonationOpen, setIsDonationOpen] = useState(false);
  const [isAidOpen, setIsAidOpen] = useState(false);

  //state responsible for transitioning between modals
  const [isAidToDonation, setAidToDonation] = useState(false);

  //this useEffect create a minor parallax effect for Giving
  useEffect(() => {
    gsap.to(container.current, {
      yPercent: 30,
      scrollTrigger: {
        trigger: container.current,
        start: "top 80%",
        // markers:true,
        scrub: true,
      },
    });
  }, []);

  //functions to open various modals
  const openCurveName = () => {
    setIsCurveModalOpen(true);
  };
  const openLSE = () => {
    setIsLSEOpen(true);
  };
  const openSponsor = () => {
    setIsSponsorOpen(true);
  };
  const openDonation = () => {
    setIsDonationOpen(true);
  };
  const openAid = () => {
    setIsAidOpen(true);
  };

  //function to close opened modal
  const cancel = () => {
    setIsCurveModalOpen(false);
    setIsLSEOpen(false);
    setIsSponsorOpen(false);
    setIsDonationOpen(false);
    setIsAidOpen(false);
    setAidToDonation(false);
  };
  //modal to transition from Aid Modal to Donation Modal
  const aidToDonation = () => {
    setAidToDonation(true);
  };

  return (
    <div className={classes.container}>
      {/* ######### MODALS ##########*/}
      {isCurveModalOpen && (
        <Modal cancel={cancel} title="Curve Your Name" circle={3000}>
          <CurveNameForm></CurveNameForm>
        </Modal>
      )}
      {isLSEOpen && (
        <Modal cancel={cancel} title="SPONSOR A CHILD AT LSE" circle={3000}>
          <LSEForm />
        </Modal>
      )}
      {isSponsorOpen && (
        <Modal cancel={cancel} title="SPONSOR OUR EVENTS" circle={3000}>
          <SponsorEventsForm />
        </Modal>
      )}
      {isDonationOpen && (
        <Modal cancel={cancel} title="Make A Donation" circle={3000}>
          <DonationForm />
        </Modal>
      )}
      {isAidOpen && (
        <Modal cancel={cancel} title="Aid Channel" circle={3000}>
          {isAidToDonation ? (
            <DonationForm />
          ) : (
            <AidForm aidToDonation={aidToDonation} />
          )}
        </Modal>
      )}
      {/*############# Buttons #############*/}
      <div ref={container}>
        <Button
          className={classes.card + " " + classes.pos1}
          backgroundColor={"#265f94"}
          onClick={openLSE}
        >
          <h2>
            Sponsor a<br /> Child
            <br /> At <span className={classes.yellow}>LSE</span>
          </h2>
        </Button>
        <Button
          className={classes.card + " " + classes.pos2}
          backgroundColor={"#265f94"}
          onClick={openDonation}
        >
          <h2>
            Make a<br />
            <span className={classes.yellow}>Donation</span>
          </h2>
        </Button>
        <Button
          className={classes.card + " " + classes.pos3}
          backgroundColor={"#265f94"}
          onClick={openAid}
        >
          <h2>
            Aid <br />
            Channel
          </h2>
        </Button>
        <Button
          className={classes.card + " " + classes.pos4}
          backgroundColor={"#265f94"}
          onClick={openSponsor}
        >
          <h2>
            Sponsor <br /> Our <br />
            Events
          </h2>
        </Button>
        <Button
          className={classes.card + " " + classes.pos5}
          backgroundColor={"#265f94"}
          onClick={openCurveName}
        >
          <h2>
            Carve
            <br />
            <span className={classes.yellow}>Your</span>
            <br />
            Name
          </h2>
        </Button>
      </div>
    </div>
  );
};
export default Giving;
